import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WorkstepActions, WorkstepActitonTypes } from './workstep.actions';
import { Workstep } from '../../../_models/workstep';
import * as fromRoot from '../../../state/app.reducer';

export interface State extends fromRoot.State {
  worksteps: WorkstepState;
}

export interface WorkstepState {
  currentWorkstep: Workstep;
  workstepList: Workstep[];
  filterFields: any;
  error: string;
}

const initialItem: Workstep = {
  id: null,
  name: '',
  description: '',
  producttype: null,
  stationsno: null,
  station0: '',
  station1: '',
  station2: '',
  station3: '',
  minutesakilo: null,
  minutesaday: null,
  acronym: '',
  abbreviation: '',
  flip: null,
  createdAt: null
};

const initialState: WorkstepState = {
  currentWorkstep: initialItem,
  workstepList: [],
  filterFields: [],
  error: '',
};

const getWorkstepFeatureState = createFeatureSelector<WorkstepState>('worksteps');

export const getCurrentWorkstep = createSelector(getWorkstepFeatureState, state => state.currentWorkstep);
export const getWorkstepList    = createSelector(getWorkstepFeatureState, state => state.workstepList);
export const getFilterFields    = createSelector(getWorkstepFeatureState, state => state.filterFields);
export const getError           = createSelector(getWorkstepFeatureState, state => state.error);

export function reducer(state = initialState, action: WorkstepActions): WorkstepState {
  switch (action.type) {
    case WorkstepActitonTypes.ClearWorkstep:
      console.log('>>>> Running ClearWorkstep action');

      return {
        ...state,
        currentWorkstep: null
      };

    case WorkstepActitonTypes.InicializeWorkstep:
      console.log('>>>> Running InicializeWorkstep action');
      state = initialState;

      return state;

    case WorkstepActitonTypes.SetCurrentWorkstep:
      console.log('>>>> Running SetCurrentWorkstep action');

      if (action.payload !== null) {
        return {
          ...state,
          currentWorkstep: action.payload
        };
      } else {
        return {
          ...state,
          currentWorkstep: initialItem
        };
      }

    case WorkstepActitonTypes.SetFilterFields:
      console.log('>>>> Running SetCurrentWorkstep action');

      return {
        ...state,
        filterFields: action.payload
      };

    case WorkstepActitonTypes.LoadWorkstepsSuccess:
      console.log('>>>> Running LoadWorkstepsSuccess action');
      console.log('--[] RETURNED PAYLOAD:');
      console.log(action.payload);

      return {
        ...state,
        workstepList: action.payload,
        error: ''
      };

    case WorkstepActitonTypes.LoadWorkstepsFail:
      console.log('>>>> Running SetCurrentWorkstep action');
      // console.log(action.payload);

      return {
        ...state,
        workstepList: [],
        error: action.payload
      };

    case WorkstepActitonTypes.CreateWorkstepSuccess:
      console.log('>>>> Running CreateWorkstepSuccess action');

      if (action.payload !== undefined) {
        console.log('--[] THE NEW CREATED ORDER REMAKE IS:');
        console.log(action.payload);

        if (action.payload !== null) {
          state.workstepList.push(action.payload);

          return {
            ...state,
            workstepList: state.workstepList,
            currentWorkstep: action.payload,
            error: ''
          };
        }
        return state;

      } else {
        console.log('---> The element to create is empty.');

        return {
          ...state,
          workstepList: null,
          error: 'The API has not been able to create the Workstep'
        };
      }

    case WorkstepActitonTypes.CreateWorkstepFail:
      console.log('>>>> Running CreateWorkstepFail action');

      return {
        ...state,
        currentWorkstep: null,
        error: action.payload
      };

    case WorkstepActitonTypes.UpdateWorkstepSuccess:
      console.log('>>>> Running UpdateWorkstepSuccess action');

      let auxWorkstepList = [];

      if (action.payload !== undefined) {
        console.log('--[] THE WORKSTEP TO MODIFY IS:');
        console.log(action.payload);

        if (action.payload != null) {
          auxWorkstepList = state.workstepList.map(item => action.payload.id === item.id ? action.payload : item);

          return {
            ...state,
            workstepList: auxWorkstepList,
            currentWorkstep: action.payload,
            error: ''
          };
        }
        return state;

      } else {
        console.log('---> The element to modify is empty.');

        return {
          ...state,
          workstepList: null,
          error: 'The API has not been able to modify the Workstep'
        };
      }

    case WorkstepActitonTypes.UpdateWorkstepFail:
      console.log('>>>> Running SetCurrentWorkstep action');

      return {
        ...state,
        error: action.payload
      };

    case WorkstepActitonTypes.DeleteWorkstepSuccess:
      console.log('>>>> Running DeleteWorkstepSuccess action');

      if (action.payload !== undefined) {
        console.log(`--[] DELETED WORKSTEP ID: ${action.payload}`);

        if (action.payload !== null) {
          // REMOVE ELEMENTS FROM LIST WITH FILTER
          const filteredList = state.workstepList.filter(
            (item) => item.id.toString() !== action.payload.toString()
          );

          console.log('---> Workstep List without the deleted workstep:');
          console.log(filteredList);

          return {
            ...state,
            workstepList: filteredList,
            currentWorkstep: null,
            error: ''
          };
        }
        return state;

      } else {
        console.log('--> The Workstep to delete is empty.');

        return {
          ...state,
          currentWorkstep: null,
          error: 'The API has not been able to delete the workstep'
        };
      }

    case WorkstepActitonTypes.DeleteWorkstepFail:
      console.log('>>>> Running DeleteWorkstepFail action');

      return {
        ...state,
        currentWorkstep: null,
        error: action.payload
      };

    default:
      return state;
  }
}
